import { render, staticRenderFns } from "./propertyMatchingForm.vue?vue&type=template&id=5fc6836b&scoped=true&"
import script from "./propertyMatchingForm.vue?vue&type=script&lang=js&"
export * from "./propertyMatchingForm.vue?vue&type=script&lang=js&"
import style0 from "./propertyMatchingForm.vue?vue&type=style&index=0&id=5fc6836b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6836b",
  null
  
)

export default component.exports